export default __webpack_public_path__ + "static/lowry-0ea118600cd89bec070d59ff4ce0e539.svg";